


















































































































































































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import ApiHelper from 'api-helper';
import datetime from 'vuejs-datetimepicker';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import lodash, { cloneDeep, isArray } from 'lodash';

import { Roles } from '@common/app.config';
import Toast from '@/common/helpers/toast';
import PageLoader from '@components/common/PageLoader.vue';
import PopupConfirm from '@/components/common/PopupConfirm.vue';
import PopupDelete from '@/components/common/PopupCourseDelete.vue';
import UploadImage from '@/components/common/UploadImage.vue';
import ToggleSwitch from '@/components/common/ToggleSwitch.vue';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import PopupAddMedicine from '@/components/common/PopupAddMedicine.vue';
import PopupAddClinic from '@/components/common/PopupAddClinic.vue';
import PopupAddMenu from '@/components/common/PopupAddMenu.vue';
import { Regexs } from '@/common/constants/regex';
import PopupChangeStatus from '@/components/common/PopupChangeStatus.vue';
import { Clinic } from '@/models/clinic';


@Component({
  components: {
    PageLoader,
    UploadImage,
    datetime,
    PopupConfirm,
    PopupDelete,
    DatePicker,
    PopupAddMedicine,
    PopupAddClinic,
    PopupAddMenu,
    ToggleSwitch,
    PopupChangeStatus,
  },
})
export default class PlanDetail extends Vue {
  showTimePanel = false;
  REGEX = Regexs;

  private get courseForm() {
    return this.$refs.courseForm as any;
  }

  get isCreate() {
    return this.$route.name === 'plans.create';
  }

  get getRulesPrice() {
    const rules = { required: true, regex: Regexs.numberNotStartWithZero, min: 0, numeric: true };

    if (+this.course.payment_type === 2) {
      rules['same_price'] = this.course.price_first;
    }

    return rules;
  }

  get isRequireMenu() {

    if (!this.course.is_shampoo_subscription) {
      return this.menus.length === 0;
    } else {
      return false;
    }
  }

  get isRequireMedicine() {
    return this.medicines.length <= 0;
  }

  public get numericErrorMessages() {
    return {
      regex: '最初の0を外してください。',
    };
  }

  get canAddApproach() {
    return this.approaches[this.approaches.length - 1] !== '';
  }

  @State((state) => state.auth.currentUser) currentUser!: any;
  course: any = {};
  isLoading: boolean = false;
  image: any = null;
  dateRange: Date[] = [];
  isSubmit: boolean = false;
  isSubmitDelete: boolean = false;
  defaultData: any = {
    name: '',
    description: '',
    payment_type: 1,
    cycle: '30',
    price_first: '',
    price_after: '',
    price_show: '0',
    price_show_with_tax: '0',
    price_base_first: '',
    price_base_after: '',
    display_order: '',
    status: 1,
    start: '',
    end: '',
    detail: '',
    image: '',
    karte_status: false,
    karte_end: '',
    karte_start: '',
    is_shampoo_subscription: false,
    is_default: false,
    is_hospital_prescription: false,
    auto_suggestion_status: false,
  };
  isChangeUpdateForm: boolean = false;
  medicines: any[] = [];
  medicalServices: any[] = [];
  clinics: any[] = [];
  menus: any[] = [];
  messageMenu: string = '';
  role: string = '';
  userNameContent: string = '';
  approaches: string[] = [];
  isDefaultChange: boolean = this.course.is_default || false;
  isLoadingSwitch: boolean = false;
  isShowPlanListModal = false;


  get clinicSelected() {
    return this.clinics && this.clinics.length
      ? cloneDeep(this.clinics)
      : [];
  }

  get isAdmin() {
    return this.currentUser.role === Roles.superAdmin;
  }

  get clinicNames() {
    return this.clinics.map((item: Clinic) => item.name).join('、');
  }

  mounted() {
    this.getCourseDetail();
    library.add(faTrashAlt);
    dom.watch();
  }

  setMenu(data) {
    this.menus = [data];
    this.isChangeUpdateForm = true;

    // let menuIds: any[] = [];
    // this.menus.map((data) => {
    //   menuIds = [...menuIds, data.id];
    //   return menuIds;
    // });
    this.course.menu_ids = [data.id];
    this.hiddenPopup('popup-add-menu');
  }

  addApproach() {
    this.approaches.push('');
    this.$nextTick(() => {
      const inputs = this.$el.querySelectorAll('.approach-item input') as NodeListOf<HTMLInputElement>;
      if (inputs.length > 0) {
        const lastInput = inputs[inputs.length - 1];
        lastInput.focus();
      }
    });
  }

  removeApproach(index) {
    this.approaches.splice(index, 1);
  }

  updateApproach(index: number, value: string) {
    this.approaches[index] = value;

    if (!value.trim()) {
      this.$set(this.approaches, index, '');
    }
  }

  showMenu(event) {
    event.preventDefault();
    event.stopPropagation();

    this.isShowPlanListModal = !this.isShowPlanListModal;

    if (this.clinics.length > 0) {
      this.messageMenu = '';
      this.showPopup(event, 'popup-add-menu');
      return;
    } else {
      this.messageMenu = 'クリニック・サロンを選択してください。';
      return;
    }
  }

  resetDate(name: string) {
    if (name == 'auto_suggestion_status') {
      this.course.start = '';
      this.course.end = '';
      return;
    }

    if (name == 'karte_status') {
      this.course.karte_start = '';
      this.course.karte_end = '';
      return;
    }
  }

  setClinic(data) {
    this.clinics = isArray(data) ? data : [data];
  }

  toggleTimePanel() {
    this.showTimePanel = !this.showTimePanel;
  }
  handleOpenChange() {
    this.showTimePanel = false;
  }

  handleClickShampooSubs(event) {
    event.preventDefault();
    event.stopPropagation();

    this.course.is_shampoo_subscription = true;
    this.course.auto_suggestion_status = false;
    this.course.karte_status = false;
    this.course.is_hospital_prescription = false;
    this.course.menu_ids = [];
    this.course.menus = [];
    this.menus = [];
    this.course.karte_start = '';
    this.course.karte_end = '';
    this.course.start = '';
    this.course.end = '';
  }

  getCourseDetail() {
    if (this.isLoading) {
      return;
    }

    if (this.isCreate) {
      this.course = this.defaultData;
    } else {
      this.isLoading = true;
      ApiHelper.getApi('CourseApi')
        .getCourseDetails(this.$route.params.id)
        .then((res: any) => {
          this.course = res;
          this.image = this.course.image_url;
          this.isLoading = false;

          // medicine
          this.medicines = lodash.forEach(this.course.medicines, (medicine: any) => {
            lodash.set(medicine, 'quantity', medicine.pivot.quantity);
            lodash.set(medicine, 'unit', medicine.pivot.unit);
          });
          let medicine_selected: any[] = [];
          this.medicines.map((data) => {
            medicine_selected = [...medicine_selected, { id: data.id, quantity: data.pivot.quantity, unit: data.pivot.unit }];
            return medicine_selected;
          });
          this.course.medicine_selected = medicine_selected;

          // clinic
          this.clinics = this.course.clinics;
          let clinic_ids: any[] = [];

          this.clinics.map((data) => {
            clinic_ids = [...clinic_ids, data.id];
            return clinic_ids;
          });
          this.course.clinic_ids = clinic_ids;

          // menu
          this.menus = this.course.menus;
          let menu_ids: any[] = [];

          this.menus.map((data) => {
            menu_ids = [...menu_ids, data.id];
            return menu_ids;
          });
          this.course.menu_ids = menu_ids;
          this.isDefaultChange = this.course.is_default;
          // tags
          if (this.course.tags) {
            this.approaches = this.course.tags;
            return;
          }
        })
        .catch((error: any) => {
          this.isLoading = false;
          if (error.response) {
            Toast.error(error.response.data.message);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }

  backToList() {
    const queryParams = lodash.pickBy({
      id: this.$route.query.id || '',
      name: this.$route.query.name || '',
      clinic_name: this.$route.query.clinic_name || '',
      menu_name: this.$route.query.menu_name || '',
      page: this.$route.query.page ? this.$route.query.page.toString() : '1',
    }, lodash.identity);

    this.$router.push({
      name: 'plans',
      query: queryParams,
    });
  }

  changeAvatar(event) {
    this.image = event;
  }

  handleToggleSwitchChange(event) {
    this.isDefaultChange = event;
    if (this.isCreate) {
      this.handleSetIsDefaultChange({ isDefault: event, isCancel: false });
    } else {
      this.$modal.show('popup-change-status');
      this.isLoadingSwitch = true;
    }
  }

  handleSetIsDefaultChange(data) {
    const isDefault = data.isDefault;
    const isCancel = data.isCancel;

    if (isCancel) {
      this.$set(this.course, 'is_default', this.course.is_default);
      this.$modal.hide('popup-change-status');
      this.isDefaultChange = this.course.is_default;
      this.isLoadingSwitch = false;
      return;
    }
    this.menus = [];

    this.$set(this.course, 'is_default', isDefault);

    if (isDefault) {
      this.isLoadingSwitch = true;
      ApiHelper.getApi('ClinicApi')
        .list()
        .then((res: any) => {
          let clinics = [];
          if (this.currentUser.isAdminRole) {
            const curUserClinic = this.currentUser.clinics[0];
            const newRes = res.data.filter(
              (item) => item.id === curUserClinic.id,
            );
            clinics = newRes.map((item) =>
              new Clinic().deserialize(item),
            );
          } else {
            clinics = res.data.map((item) =>
              new Clinic().deserialize(item),
            );
          }
          this.clinics = clinics;
        })
        .catch((error: any) => {
          Toast.error(error.response.data.message);
        })
        .finally(() => {
          this.isLoadingSwitch = false;
          this.$modal.hide('popup-change-status');
        });
    } else {
      this.clinics = [];
      this.isLoadingSwitch = false;
      this.$modal.hide('popup-change-status');
    }
  }


  deleteImage() {
    this.image = '';
    this.course.image_url = '';
  }

  async handleSubmit() {
    const isValid = await this.courseForm.validate();
    if (!isValid) {
      Toast.error('正しく入力してください。');
      return;
    }

    if (!this.course['medicine_selected'] || this.course['medicine_selected'].length <= 0) {
      Toast.error('商品を選択してください。');
      return;
    }

    if (!this.isCreate) {
      this.isLoading = true;
      const users = await ApiHelper.getApi('CourseApi')
        .getUserUsingCourse(this.$route.params.id);

      if (users.length <= 0) {
        await this.submitCourse();
        return;
      }

      users.forEach((user) => {
        this.userNameContent += `<span>${user.family_name} ${user.given_name}</span> <br/>`;
      });

      this.$modal.show('comfirmSubmitCourse');
      this.isLoading = false;
      return;
    } else {
      await this.submitCourse();
      return;
    }
  }

  async showPopupConfirmDeleteCourse() {
    this.$modal.show('comfirmDeleteCourse');
  }

  cancelPopupConfirmDelete() {
    this.$modal.hide('comfirmDeleteCourse');
  }

  deleteCourse() {
    this.isSubmitDelete = true;
    ApiHelper.getApi('CourseApi')
      .deleteCourse(this.$route.params.id)
      .then((res: any) => {
        this.$router.push({ name: 'plans' });
        Toast.success('削除しました');
      })
      .catch((error: any) => {
        this.isLoading = false;
        if (error.response) {
          Toast.error(error.response.data.message);
        }
      })
      .finally(() => {
        this.isSubmitDelete = false;
      });
  }

  cancelPopupConfirmSubmit() {
    this.userNameContent = '';
    this.$modal.hide('comfirmSubmitCourse');
  }

  setMedicine(medicines) {
    this.medicines = medicines;
    this.isChangeUpdateForm = true;

    let medicineSelected: any[] = [];
    this.medicines.map((data) => {
      medicineSelected = [...medicineSelected, { id: data.id, quantity: data.quantity, unit: data.unit?.value ?? data.unit }];
      return medicineSelected;
    });
    this.course.medicine_selected = medicineSelected;
    this.hiddenPopup('popup-add-medicine');

    return;
  }

  async submitCourse() {
    this.isLoading = true;
    this.isSubmit = true;
    const data = new FormData();

    for (const key in this.course) {
      if (this.course[key] !== null && this.course[key] !== '') {
        if (
          (key === 'menu_ids') &&
          this.course[key].length > 0
        ) {
          this.course[key].map((keyId) => {
            data.append(`${key}[]`, keyId);
            return keyId;
          });
        } else if (key === 'medicine_selected') {
          this.course[key].map((value) => {
            data.append(`${key}[${value.id}][quantity]`, value.quantity);
            data.append(`${key}[${value.id}][unit]`, value.unit);
            return value;
          });
        } else if (key !== 'clinic_ids') {
          data.append(key, this.course[key]);
        }
      }
    }
    if (this.approaches.length > 0) {
    this.approaches.map((element) => {
      data.append('tags[]', element);
    });
    }
    if (this.image && this.image instanceof File) {
      data.append('avatar', this.image);
    }
    if (this.course.start) {
      data.set('start', moment(this.course.start).format('YYYY-MM-DD HH:mm'));
    }
    if (this.course.end) {
      data.set('end', moment(this.course.end).format('YYYY-MM-DD HH:mm'));
    }
    if (this.course.karte_start) {
      data.set('karte_start', moment(this.course.karte_start).format('YYYY-MM-DD HH:mm'));
    }
    if (this.course.karte_end) {
      data.set('karte_end', moment(this.course.karte_end).format('YYYY-MM-DD HH:mm'));
    }
    if (this.clinics.length > 0) {
      this.clinics.map((value) => {
        data.append('clinic_ids[]', value.id);
      });
    }
    data.set('is_default', this.course.is_default ? '1' : '0');
    data.delete('medicines');
    data.delete('menus');
    data.delete('clinics');
    if (!data['menu_ids']) {
      data.delete('menu_ids');
    }
    if (this.isCreate) {
      ApiHelper.getApi('CourseApi')
        .createCourse(data, this.$route.params.id)
        .then((res: any) => {
          this.course = res;
          this.isLoading = false;
          this.$router.push({ name: 'plans' });
          Toast.success('登録しました');
        })
        .catch((error: any) => {
          this.isLoading = false;
          if (error.response) {
            Toast.error(error.response.data.message);
          }
        })
        .finally(() => {
          this.isLoading = false;
          this.isSubmit = false;
        });
    } else {
      ApiHelper.getApi('CourseApi')
        .updateCourse(data, this.$route.params.id)
        .then((res: any) => {
          this.course = res;
          this.isLoading = false;
          this.$router.push({ name: 'plans' });
          Toast.success('登録しました');
        })
        .catch((error: any) => {
          this.isLoading = false;
          if (error.response) {
            Toast.error(error.response.data.message);
          }
          const { data, status } = error.response;
          if (status === 422) {
            this.courseForm.setErrors(data.errors);
            return;
          }
        })
        .finally(() => {
          this.isLoading = false;
          this.isSubmit = false;
        });
    }
  }

  private hiddenPopup(name) {
    this.$modal.hide(name);
  }

  private showPopup(event, name) {
    event.preventDefault();
    event.stopPropagation();

    this.$modal.show(name);
  }

  private disabledStartDatePicker(date) {
    return moment(date).isAfter(moment(this.course.end));
  }

  private disableStartTime(date) {
    return moment(date).format('YYYY-MM-DD HH:mm') >= moment(this.course.end, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
  }

  private disabledEndDatePicker(date) {
    return moment(date).format('YYYY-MM-DD') < moment(this.course.start, 'YYYY-MM-DD').format('YYYY-MM-DD');
  }

  private disableEndTime(date) {
    return moment(date).format('YYYY-MM-DD HH:mm') <= moment(this.course.start, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
  }

  private disabledStartKarteDatePicker(date) {
    return moment(date).isAfter(moment(this.course.karte_end));
  }

  private disableStartKarteTime(date) {
    return moment(date).format('YYYY-MM-DD HH:mm') >= moment(this.course.karte_end, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
  }

  private disabledEndKarteDatePicker(date) {
    return moment(date).format('YYYY-MM-DD') < moment(this.course.karte_start, 'YYYY-MM-DD').format('YYYY-MM-DD');
  }

  private disableEndKarteTime(date) {
    return moment(date).format('YYYY-MM-DD HH:mm') <= moment(this.course.karte_start, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
  }

}
